import { render } from "./EditorView.vue?vue&type=template&id=ca3e35f2&scoped=true&ts=true"
import script from "./EditorView.vue?vue&type=script&lang=ts"
export * from "./EditorView.vue?vue&type=script&lang=ts"

import "./EditorView.vue?vue&type=style&index=0&id=ca3e35f2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca3e35f2"]])

export default __exports__